import script from "./RouteChangeDialog.vue?vue&type=script&lang=jsx"
export * from "./RouteChangeDialog.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__